<template>
  <v-container fluid>
    <v-row>
      <v-col cols="2">
        <v-select
          @change="value => handleChange('dataType', value)"
          label="Стата"
          :items="dataTypeOptions"
          :value="dataType"
        />
      </v-col>

      <template v-if="dataType === DATA_TYPE.ACTION_AGGREGATES">
        <v-col cols="2">
          <v-select
            v-model="departmentValue"
            :items="departmentOptions"
            :loading="loading"
            :placeholder="'Выберите отдел'"
          />
        </v-col>

        <v-col cols="1" v-if="departmentValue === REGISTER">
          <v-select
            v-model="actionTagValue"
            :items="actionTagOptions"
            :loading="loading"
            :placeholder="'Таг'"
            clearable
          />
        </v-col>
      </template>

      <template v-if="dataType === DATA_TYPE.CHAT_VISITS">
        <v-col cols="2">
          <v-autocomplete
            v-model="supportIdValue"
            :items="supportOptions"
            :loading="loading"
            :label="'Саппорт'"
            :placeholder="'Выберите саппорта'"
            clearable
          />
        </v-col>
      </template>

      <v-col class="pa-0">
        <date-filter
          v-if="dataType !== DATA_TYPE.CHATS"
          @change="handleChange"
          @submit="handleSubmit"
          :date="date"
          :dateRange="dateRange"
          :loading="loading"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DateFilter from '../../../components/common/date-filter/DateFilter.vue';
import { DATA_TYPE } from './const';
import { DEPARTMENT, DEPARTMENTS } from '@/models/departments';
import { CHAT_ACTION_TAGS } from '@/models/actions';

const { REGISTER, FINANCES } = DEPARTMENT;
const ENABLED_DEPARTMENT_IDS = [REGISTER, FINANCES];

export default {
  name: 'StatisticsFilters',

  components: {
    DateFilter,
  },

  props: {
    date: String,
    dateRange: String,
    dataType: String,
    loading: Boolean,
  },

  data() {
    return {
      DATA_TYPE,
      REGISTER,

      dataTypeOptions: [
        {
          text: 'Чаты',
          value: DATA_TYPE.CHATS,
        },
        {
          text: 'Саппорты',
          value: DATA_TYPE.SUPPORTS,
        },
        {
          text: 'Действия',
          value: DATA_TYPE.ACTIONS,
        },
        {
          text: 'Действия (Агрегация)',
          value: DATA_TYPE.ACTION_AGGREGATES,
        },
        {
          text: 'Активность по чатам',
          value: DATA_TYPE.CHAT_VISITS,
        },
      ],

      departmentValue: REGISTER,
      departmentOptions: DEPARTMENTS.filter(({ id }) =>
        ENABLED_DEPARTMENT_IDS.includes(id)
      ).map(({ id, name }) => ({ text: name, value: id })),
      actionTagOptions: CHAT_ACTION_TAGS,
      actionTagValue: null,

      supportIdValue: null,
    };
  },

  computed: {
    supportOptions() {
      return this.$store.state.adminSupport.supports.map(
        ({ azureProviderId, nickname }) => ({
          text: nickname,
          value: azureProviderId,
        })
      );
    },
  },

  methods: {
    handleChange(key, value) {
      this.$emit('change', key, value);
    },

    handleSubmit() {
      if (this.dataType === DATA_TYPE.ACTION_AGGREGATES) {
        const additionalFilters = {
          department: this.departmentValue,
          ...(this.actionTagValue && this.departmentValue === REGISTER
            ? { tag: this.actionTagValue }
            : {}),
        };
        return this.$emit('submit', additionalFilters);
      }

      if (this.dataType === DATA_TYPE.CHAT_VISITS) {
        const additionalFilters = {
          supportId: this.supportIdValue,
        };
        return this.$emit('submit', additionalFilters);
      }

      this.$emit('submit');
    },
  },
};
</script>
